/** START new mapping additions that were not part of old ChatAI **/
export const VEHICLE_DETAILS_PAGE = 'carvana_vdp';
/** END new mapping additions that were not part of old ChatAI **/

export const DEFAULT_ORIGIN_VENDOR = 'carvana_homepage';
export const DEFAULT_CARVANA_URL = 'Carvana.com';
export const LOCAL_HOST = 'carvana_localhost';

export const TRADE_ORIGIN_DEFAULT = 'carvana_trade';
export const TRADE_ORIGIN_NEW = 'carvana_trade_new';
export const TRADE_ORIGIN_BREAKDOWN = 'carvana_trade_breakdown';
export const TRADE_ORIGIN_BFP = 'carvana_trade_bfp';
export const TRADE_ORIGIN_DOCUMENT_REVIEW = 'carvana_trade_documents_review';
export const TRADE_ORIGIN_GET_VALUE = 'carvana_trade_get_value';
export const TRADE_ORIGIN_VALUED = 'carvana_trade_valued';
export const TRADE_ORIGIN_DECLINE_REASON = 'carvana_trade_declined_reason';
export const TRADE_ORIGIN_DECLINED = 'carvana_trade_declined';
export const TRADE_ORIGIN_UNDERWRITING = 'carvana_trade_underwriting';

export const ACQUISITION_ORIGIN_PERSONAL_DETAILS_HOME = 'carvana_pp_personal_details_home';
export const ACQUISITION_ORIGIN_PERSONAL_DETAILS_SUMMARY = 'carvana_pp_personal_details_summary';
export const ACQUISITION_ORIGIN_PERSONAL_DETAILS_ENTRY = 'carvana_pp_personal_details_entry';

export const ACQUISITION_ORIGIN_PAYMENT = 'carvana_pp_payment';
export const ACQUISITION_ORIGIN_PAYMENT_OPTIONS_TYPE = 'carvana_pp_payment_options_type';
export const ACQUISITION_ORIGIN_PAYMENT_OPTIONS_BUILD_DEAL =
  'carvana_pp_payment_options_build_deal';
export const ACQUISITION_ORIGIN_PAYMENT_OPTIONS_THIRD_PARTY =
  'carvana_pp_payment_options_3rd_party';
export const ACQUISITION_ORIGIN_PAYMENT_OPTIONS_PERSONAL_DETAILS =
  'carvana_pp_payment_options_personal_details';

export const ACQUISITION_ORIGIN_GAP_AVAILABLE = 'carvana_pp_gap_available';
export const ACQUISITION_ORIGIN_GAP_UNAVAILABLE = 'carvana_pp_gap_unavailable';
export const ACQUISITION_ORIGIN_TRADE_GET_VALUE = 'carvana_pp_trade_get_value';
export const ACQUISITION_ORIGIN_TRADE_VALUED = 'carvana_pp_trade_valued';
export const ACQUISITION_ORIGIN_TRADE_DECLINED_REASON = 'carvana_pp_trade_declined_reason';
export const ACQUISITION_ORIGIN_TRADE_DECLINED = 'carvana_pp_trade_declined';
export const ACQUISITION_ORIGIN_TRANSFER_METHOD_EDIT_DELIVERY_ADDRESS =
  'carvana_pp_transfer_method_edit_address';
export const ACQUISITION_ORIGIN_TRANSFER_METHOD_DEFAULT = 'carvana_pp_transfer_method';

export const ACQUISITION_ORIGIN_ANCILLARY = 'carvana_pp_protection_ancillary';
export const ACQUISITION_ORIGIN_MISSING_PERSONAL_DETAILS =
  'carvana_pp_protection_missing_personal_details';
export const ACQUISITION_ORIGIN_PROTECTION_UNAVAILABLE = 'carvana_pp_protection_unavailable';
export const ACQUISITION_ORIGIN_DRIVER_LICENSE_UPLOAD = 'carvana_pp_dl_upload';
export const ACQUISITION_ORIGIN_DRIVER_LICENSE_PENDING = 'carvana_pp_dl_pending';
export const ACQUISITION_ORIGIN_DRIVER_LICENSE_HOME = 'carvana_pp_dl';
export const ACQUISITION_ORIGIN_IDENTITY_PERSONAL_DETAILS = 'carvana_pp_identity';
export const ACQUISITION_ORIGIN_REVIEW_ORDER = 'carvana_pp_review_order';
export const ACQUISITION_ORIGIN_CUSTOMER_SCHEDULE = 'carvana_pp_transfer_schedule';
export const ACQUISITION_ORIGIN_CONTRACTS_FINISHED = 'carvana_pp_contracts_finished';
export const ACQUISITION_ORIGIN_CONTRACTS_SAVE = 'carvana_pp_contracts_save';
export const ACQUISITION_ORIGIN_CONTRACTS_OPTOUT = 'carvana_pp_contracts_optout';
export const ACQUISITION_ORIGIN_CONTRACTS_ERROR = 'carvana_pp_contracts_error';
export const ACQUISITION_ORIGIN_CONTRACTS_DEFAULT = 'carvana_pp_contracts';

export const ACQUISITION_ORIGIN_OPD = 'carvana_pp_opd';
export const ACQUISITION_ORIGIN_CUSTOMER_DELIVERY_DETAILS = 'carvana_pp_opd_delivery_details';
export const ACQUISITION_ORIGIN_CUSTOMER_DOCUMENTS_VERIFICATIONS =
  'carvana_pp_opd_documents_verifications';
export const ACQUISITION_ORIGIN_ERROR = 'carvana_pp_error';

export const MISC_ORIGIN_FINANCING = 'carvana_financing';
export const MISC_ORIGIN_ABOUT = 'carvana_about';
export const MISC_ORIGIN_OTHER = 'carvana_other';
export const MISC_ORIGIN_CAREER = 'carvana_career';
export const MISC_ORIGIN_ANCILLARY = 'carvana_ancillary';
export const MISC_ORIGIN_POST_ORDER = 'carvana_post_order_placed';
export const MISC_ORIGIN_CONTRACTS = 'carvana_contracts';
export const MISC_ORIGIN_UNDERWRITING = 'carvana_underwriting';
export const MISC_ORIGIN_APP = 'carvana_app';
export const MISC_ORIGIN_CAREERS = 'carvana_careers';
export const MISC_ORIGIN_CONTACTS = 'carvana_contact';
export const MISC_ORIGIN_ERROR = 'carvana_error';
export const MISC_ORIGIN_REFERRALS = 'carvana_referrals';
export const MISC_ORIGIN_LEGAL = 'carvana_legal';
export const MISC_ORIGIN_ACCOUNT = 'carvana_account';

export const UNDERWRITING_ERROR = 'carvana_uw_error';
export const UNDERWRITING_BACKTOSEARCH = 'carvana_uw_backtosearch';
export const UNDERWRITING_PERSONAL = 'carvana_uw_personal';
export const UNDERWRITING_IDENTITY_VERIFICATION = 'carvana_uw_identity';
export const UNDERWRITING_LICENSE = 'carvana_uw_license';
export const UNDERWRITING_INCOME = 'carvana_uw_income';
export const UNDERWRITING_RESIDENCY = 'carvana_uw_residency';
export const UNDERWRITING_TRADE = 'carvana_trade_underwriting';
export const UNDERWRITING_ORDER_PERSONAL = 'carvana_uw_order_personal';
export const UNDERWRITING_ORDER_IDENTITY_VERIFICATION = 'carvana_uw_order_identity';
export const UNDERWRITING_ORDER_LICENSE = 'carvana_uw_order_license';
export const UNDERWRITING_ORDER_INCOME = 'carvana_uw_order_income';
export const UNDERWRITING_ORDER_RESIDENCY = 'carvana_uw_order_residency';
export const UNDERWRITING_ORDER_TRADE = 'carvana_uw_order_trade';

export const FINANCE_BAD_CREDIT = 'carvana_badcredit_finance';
export const VEHICLE_COVERAGE = 'carvana_vehiclecoverage';

export const CARVANA_TOUCHLESS = 'carvana_touchless';
